// extracted by mini-css-extract-plugin
module.exports = {"buyingGuides":"BuyingGuidesAccordion_buyingGuides__O_bnh","buyingGuide":"BuyingGuidesAccordion_buyingGuide__ZH8Lt","buyingGuideName":"BuyingGuidesAccordion_buyingGuideName__cWEAP"};